export default "__VITE_ASSET__Dy$7iYgE__"